unit View.Vendas_Servicos.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UConstantes, UUtils, UPersonalizacao_Tabela,
  UPersonalizacao_Tabela.Interfaces, System.StrUtils, UFrameDataBase, Vcl.Forms,
  System.DateUtils, UHelperServer, XData.Web.Client;

type
  TFViewVendas_ServicosList = class(TForm)
    Vendas_ServicosDataset: TXDataWebDataSet;
    Vendas_ServicosDatasetid: TIntegerField;
    Vendas_ServicosDatasetnota_numero: TStringField;
    Vendas_ServicosDatasetnota_emissao: TDateTimeField;
    Vendas_ServicosDatasetnota_entrada_saida: TDateTimeField;
    Vendas_ServicosDatasetnota_valor_total: TFloatField;
    Vendas_ServicosDatasetcodigo_interno: TIntegerField;
    Vendas_ServicosDatasetexcluido: TBooleanField;
    Vendas_ServicosDatasetinclusao: TDateTimeField;
    Vendas_ServicosDatasetalteracao: TDateTimeField;
    Vendas_ServicosDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    btnExportarExcel: TButton;
    tmrConsulta: TTimer;
    Vendas_ServicosDatasetfuncionarionome: TStringField;
    Vendas_ServicosDatasetclienterazao_social_nome: TStringField;
    Vendas_ServicosDatasetnfse_id: TIntegerField;
    Vendas_ServicosDatasetnfsenfse_xml_s3: TStringField;
    cbbVendasNfse: TComboBox;
    edtDataFinal: TDateTimePicker;
    edtDataInicial: TDateTimePicker;
    edtClienteNome: TEdit;
    btnPesquisarCliente: TButton;
    cbxVendasExcluidos: TCheckBox;
    frmBanco: TfrmDataBase;
    btnPesquisarVenda: TButton;
    XDataWebClient: TXDataWebClient;
    Vendas_ServicosDatasetnfseanexo_sincronizado: TXDataWebDatasetField;
    procedure WebFormCreate(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure btnExportarExcelClick(Sender: TObject);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure btnPesquisarVendaClick(Sender: TObject);
    procedure btnPesquisarClienteClick(Sender: TObject);
    procedure XDataWebClientError(Error: TXDataClientError);
    procedure XDataWebClientLoad(Response: TXDataClientResponse);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;

    procedure ConfigurarData;
    function GetFiltro : string;
    function ValidarDatas : string;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewVendas_ServicosList: TFViewVendas_ServicosList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewVendas_ServicosList }

procedure TFViewVendas_ServicosList.btnExportarExcelClick(Sender: TObject);
begin
  TUtils.ExportarDadosExcel(Vendas_ServicosDataset, WebDBTableControl1,
    FGridPlugin.FDatasetPlugin.FDataset.QueryString, FGridPlugin.FQuantidadeRegistrosBusca);
end;

procedure TFViewVendas_ServicosList.btnPesquisarClienteClick(Sender: TObject);
begin
  THelperServer.ChamarConsulta('Clientes', 'clientes', edtClienteNome);
end;

procedure TFViewVendas_ServicosList.btnPesquisarVendaClick(Sender: TObject);
begin
  ValidarDatas;

  FGridPlugin.FDatasetPlugin.FFilterPadrao := GetFiltro;
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewVendas_ServicosList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

procedure TFViewVendas_ServicosList.ConfigurarData;
begin
  edtDataFinal.Max := Date;
  edtDataInicial.Min := IncDay(Date, -365);
  edtDataInicial.Date := IncDay(Date, -365);
  edtDataFinal.Date := Date;
end;

class function TFViewVendas_ServicosList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewVendas_ServicosList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewVendas_ServicosList, AElementID, Result, @AfterCreate);
end;

procedure TFViewVendas_ServicosList.edSearchKeyDown(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
    FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewVendas_ServicosList.edSearchKeyUp(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

function TFViewVendas_ServicosList.GetFiltro: string;
var
  lListaFiltro : TStringList;
  lFiltroBanco : string;
begin
  Result := EmptyStr;
  lListaFiltro := TStringList.Create;

  try
    if not cbxVendasExcluidos.Checked then
      lListaFiltro.Add('(excluido eq false)');

    if edtClienteNome.Tag <> 0 then
      lListaFiltro.Add('(cliente_id eq '+edtClienteNome.Tag.ToString+')');

    if ((edtDataInicial.Text <> '') and (edtDataFinal.Text <> '')) then
    begin
      lListaFiltro.Add('((nota_emissao ge '+edtDataInicial.Text+') and ' +
        '(nota_emissao le '+edtDataFinal.Text+'))');
    end;

    lFiltroBanco := frmBanco.GetFilterDataBase;

    if not lFiltroBanco.IsEmpty then
      lListaFiltro.Add('(data_base_id eq '+lFiltroBanco+')');

    case cbbVendasNfse.ItemIndex of
      1: lListaFiltro.Add('(nfse_id ne null)');
      2: lListaFiltro.Add('(nfse_id eq null)');
    end;

    if lListaFiltro.Count > 0 then
      Result := string.Join(' and ', lListaFiltro.ToStringArray);
  finally
    if Assigned(lListaFiltro) then
      FreeAndNil(lListaFiltro)
  end;
end;

procedure TFViewVendas_ServicosList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

function TFViewVendas_ServicosList.ValidarDatas: string;
begin
  Result := EmptyStr;

  if (Trim(edtDataInicial.Text).IsEmpty) or (Trim(edtDataFinal.Text).IsEmpty) then
  begin
    Result := 'Data inicial e final são obrigatórias!';
    Exit;
  end;

  if edtDataInicial.Date > edtDataFinal.Date then
  begin
    Result := 'A data inicial deve ser menor que a final!';
    Exit;
  end;

  if DaysBetween(edtDataInicial.Date, edtDataFinal.Date) > 365 then
  begin
    Result := 'O intervalo entre as datas deve ser menor ou igual a 1 ano!';
    Exit;
  end;
end;

procedure TFViewVendas_ServicosList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;
  RecordNfseId,
  RecordVendaId : Integer;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

  procedure BaixarArquivoButtonClick(Sender: TObject);
  var
    lBotaoSelecionado : TButton;
    lJson : TJSObject;
    lBotaoNome : string;
  begin
    TUtils.ChamarDivLoading;

    lBotaoSelecionado := TButton(Sender);
    lBotaoNome := lBotaoSelecionado.Name;

    lJson := TJSObject.New;

    if lBotaoNome = 'rbtBaixarXml'  then
      lJson['tipo'] := 'xml'
    else if lBotaoNome = 'rbtBaixarDanfe' then
      lJson['tipo'] := 'danfe'
    else
    begin
      lJson['tabela'] := 'vendas_servicos';
      lJson['tipo'] := 'relatorio'
    end;

    lJson['codigo'] := lBotaoSelecionado.Tag;

    if lBotaoNome <> 'rbtBaixarRelatorio' then
      lJson['tabela'] := 'nfse';

    XDataWebClient.RawInvoke('IService.BaixarArquivo', [lJson]);
  end;

var
  Button: TButton;
  lHabilitarDanfeXml : Boolean;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ações' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Vendas_ServicosDataset.Connection.Model.DefaultSchema.FindEntityType(Vendas_ServicosDataset.EntitySetName),
      Vendas_ServicosDataset.CurrentData
    );

    RecordNfseId := Vendas_ServicosDataset.FieldByName('nfse_id').AsInteger;
    RecordVendaId := Vendas_ServicosDataset.FieldByName('id').AsInteger;

    lHabilitarDanfeXml := not Vendas_ServicosDataset.FieldByName('nfse.nfse_xml_s3').AsString.IsEmpty and
      (Vendas_ServicosDataset.FieldByName('nfse.anexo_sincronizado').AsString = '1');

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-eye"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_venda_servico');

    Button := TButton.Create(nil);
    Button.Name := 'rbtBaixarXml';
    Button.Tag := RecordNfseId;
    Button.Caption := '<i class="fas fa-file-code"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_baixar_xml');

    if lHabilitarDanfeXml then
    begin
      Button.OnClick := @BaixarArquivoButtonClick;
      Button.ElementClassName := 'btn btn-link btn-secondary btn-lg';
      Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      Button.ElementHandle.setAttribute('title', 'Baixar XML');
    end
    else
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end;

    Button := TButton.Create(nil);
    Button.Name := 'rbtBaixarDanfe';
    Button.Tag := RecordNfseId;
    Button.Caption := '<i class="fas fa-file-pdf"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_baixar_danfse');

    if lHabilitarDanfeXml then
    begin
      Button.OnClick := @BaixarArquivoButtonClick;
      Button.ElementClassName := 'btn btn-link btn-danger btn-lg';
      Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      Button.ElementHandle.setAttribute('title', 'Baixar Danfse');
    end
    else
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end;

    Button := TButton.Create(nil);
    Button.Name := 'rbtBaixarRelatorio';
    Button.Tag := RecordVendaId;
    Button.Caption := '<i class="fas fa-file-alt"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_baixar_relatorio');
    Button.OnClick := @BaixarArquivoButtonClick;
    Button.ElementClassName := 'btn btn-link btn-info btn-lg';
    Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
    Button.ElementHandle.setAttribute('title', 'Baixar Relatório');
  end;
end;

procedure TFViewVendas_ServicosList.WebDBTableControl1GetCellClass(
  Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
  var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['nota_numero', 'funcionario.nome',
     'cliente.razao_social_nome', 'nota_valor_total']) of
      0, 1, 2: AClassName := 'text-start';
      3: AClassName := 'text-end'
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewVendas_ServicosList.WebDBTableControl1GetCellData(
  Sender: TObject; ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['excluido']) of
     0:
      begin
        if AValue = 'True' then
          AValue := '<i class="fas fa-check text-success"><i>'
        else if AValue = 'False' then
          AValue := '<i class="fas fa-times text-danger"><i>';
      end;
    end;
  end;
end;

procedure TFViewVendas_ServicosList.WebFormCreate(Sender: TObject);
begin
  ConfigurarData;
  frmBanco.ConfigurarDataBase;

  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('vendas_servicos', 'active');
  TUtils.SetValorDicionarioClasses('vendas_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_vendas', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(WebDBTableControl1, Vendas_ServicosDataset, lcPaginator,
    lbPaginationInfo);

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'codigo_interno desc';
  FGridPlugin.FDatasetPlugin.FFilterPadrao := GetFiltro;
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewVendas_ServicosList.XDataWebClientError(
  Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Error.ErrorMessage);
end;

procedure TFViewVendas_ServicosList.XDataWebClientLoad(
  Response: TXDataClientResponse);
var
  lJSONObject: TJSObject;
begin
  lJSONObject := Response.ResultAsObject;
  THelperServer.BaixarAnexo(string(lJSONObject['arquivo_base64']), string(lJSONObject['arquivo_nome']));
end;

procedure TFViewVendas_ServicosList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.vendas_servicos.list.pagination.info');
  WebDBTableControl1 := TDBTableControl.Create('view.vendas_servicos.list.table');
  cbPageSize := TComboBox.Create('view.vendas_servicos.list.cbPageSize');
  edSearch := TEdit.Create('view.vendas_servicos.list.search');
  lcPaginator := TListControl.Create('view.vendas_servicos.list.pagination');
  btnExportarExcel := TButton.Create('btnExportarExcel');
  cbbVendasNfse := TComboBox.Create('cbbVendasNfse');
  edtDataFinal := TDateTimePicker.Create('edtDataFinal');
  edtDataInicial := TDateTimePicker.Create('edtDataInicial');
  edtClienteNome := TEdit.Create('edtClienteNome');
  btnPesquisarCliente := TButton.Create('btnPesquisarCliente');
  cbxVendasExcluidos := TCheckBox.Create('cbxVendasExcluidos');
  frmBanco := TfrmDataBase.Create(Self);
  btnPesquisarVenda := TButton.Create('btnPesquisarVenda');
  Vendas_ServicosDataset := TXDataWebDataSet.Create(Self);
  Vendas_ServicosDatasetcodigo_interno := TIntegerField.Create(Self);
  Vendas_ServicosDatasetnota_numero := TStringField.Create(Self);
  Vendas_ServicosDatasetclienterazao_social_nome := TStringField.Create(Self);
  Vendas_ServicosDatasetnota_emissao := TDateTimeField.Create(Self);
  Vendas_ServicosDatasetnota_entrada_saida := TDateTimeField.Create(Self);
  Vendas_ServicosDatasetnota_valor_total := TFloatField.Create(Self);
  Vendas_ServicosDatasetfuncionarionome := TStringField.Create(Self);
  Vendas_ServicosDatasetexcluido := TBooleanField.Create(Self);
  Vendas_ServicosDatasetinclusao := TDateTimeField.Create(Self);
  Vendas_ServicosDatasetalteracao := TDateTimeField.Create(Self);
  Vendas_ServicosDatasetexclusao := TDateTimeField.Create(Self);
  Vendas_ServicosDatasetid := TIntegerField.Create(Self);
  Vendas_ServicosDatasetnfse_id := TIntegerField.Create(Self);
  Vendas_ServicosDatasetnfsenfse_xml_s3 := TStringField.Create(Self);
  Vendas_ServicosDatasetnfseanexo_sincronizado := TXDataWebDatasetField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);
  XDataWebClient := TXDataWebClient.Create(Self);

  frmBanco.LoadFromForm;
  lbPaginationInfo.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  btnExportarExcel.BeforeLoadDFMValues;
  cbbVendasNfse.BeforeLoadDFMValues;
  edtDataFinal.BeforeLoadDFMValues;
  edtDataInicial.BeforeLoadDFMValues;
  edtClienteNome.BeforeLoadDFMValues;
  btnPesquisarCliente.BeforeLoadDFMValues;
  cbxVendasExcluidos.BeforeLoadDFMValues;
  frmBanco.BeforeLoadDFMValues;
  frmBanco.cbbDataBasePesquisa.BeforeLoadDFMValues;
  btnPesquisarVenda.BeforeLoadDFMValues;
  Vendas_ServicosDataset.BeforeLoadDFMValues;
  Vendas_ServicosDatasetcodigo_interno.BeforeLoadDFMValues;
  Vendas_ServicosDatasetnota_numero.BeforeLoadDFMValues;
  Vendas_ServicosDatasetclienterazao_social_nome.BeforeLoadDFMValues;
  Vendas_ServicosDatasetnota_emissao.BeforeLoadDFMValues;
  Vendas_ServicosDatasetnota_entrada_saida.BeforeLoadDFMValues;
  Vendas_ServicosDatasetnota_valor_total.BeforeLoadDFMValues;
  Vendas_ServicosDatasetfuncionarionome.BeforeLoadDFMValues;
  Vendas_ServicosDatasetexcluido.BeforeLoadDFMValues;
  Vendas_ServicosDatasetinclusao.BeforeLoadDFMValues;
  Vendas_ServicosDatasetalteracao.BeforeLoadDFMValues;
  Vendas_ServicosDatasetexclusao.BeforeLoadDFMValues;
  Vendas_ServicosDatasetid.BeforeLoadDFMValues;
  Vendas_ServicosDatasetnfse_id.BeforeLoadDFMValues;
  Vendas_ServicosDatasetnfsenfse_xml_s3.BeforeLoadDFMValues;
  Vendas_ServicosDatasetnfseanexo_sincronizado.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  XDataWebClient.BeforeLoadDFMValues;
  try
    Name := 'FViewVendas_ServicosList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 328;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#245'es';
      Width := 200;
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nota_numero';
      Title := 'Documento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cliente.razao_social_nome';
      Title := 'Cliente';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nota_emissao';
      Title := 'Emiss'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nota_entrada_saida';
      Title := 'Sa'#237'da';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nota_valor_total';
      Title := 'Valor';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'funcionario.nome';
      Title := 'Funcion'#225'rio';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'C'#243'd. Retaguarda';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'Exclu'#237'do';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 215;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 200;
    lcPaginator.Top := 365;
    lcPaginator.Width := 136;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    btnExportarExcel.SetParentComponent(Self);
    btnExportarExcel.Name := 'btnExportarExcel';
    btnExportarExcel.Left := 112;
    btnExportarExcel.Top := 63;
    btnExportarExcel.Width := 96;
    btnExportarExcel.Height := 25;
    btnExportarExcel.Caption := 'Exportar Excel';
    btnExportarExcel.ChildOrder := 11;
    btnExportarExcel.HeightPercent := 100.000000000000000000;
    btnExportarExcel.WidthPercent := 100.000000000000000000;
    SetEvent(btnExportarExcel, Self, 'OnClick', 'btnExportarExcelClick');
    cbbVendasNfse.SetParentComponent(Self);
    cbbVendasNfse.Name := 'cbbVendasNfse';
    cbbVendasNfse.Left := 344;
    cbbVendasNfse.Top := 124;
    cbbVendasNfse.Width := 120;
    cbbVendasNfse.Height := 21;
    cbbVendasNfse.HeightPercent := 100.000000000000000000;
    cbbVendasNfse.Text := 'TODOS';
    cbbVendasNfse.WidthPercent := 100.000000000000000000;
    cbbVendasNfse.ItemIndex := 0;
    cbbVendasNfse.Items.BeginUpdate;
    try
      cbbVendasNfse.Items.Clear;
      cbbVendasNfse.Items.Add('TODOS');
      cbbVendasNfse.Items.Add('SIM');
      cbbVendasNfse.Items.Add('N'#195'O');
    finally
      cbbVendasNfse.Items.EndUpdate;
    end;
    edtDataFinal.SetParentComponent(Self);
    edtDataFinal.Name := 'edtDataFinal';
    edtDataFinal.Left := 344;
    edtDataFinal.Top := 93;
    edtDataFinal.Width := 120;
    edtDataFinal.Height := 22;
    edtDataFinal.BorderStyle := bsSingle;
    edtDataFinal.ChildOrder := 109;
    edtDataFinal.Color := clWhite;
    edtDataFinal.Date := 45980.718362395830000000;
    edtDataFinal.Role := '';
    edtDataFinal.Text := '';
    edtDataInicial.SetParentComponent(Self);
    edtDataInicial.Name := 'edtDataInicial';
    edtDataInicial.Left := 344;
    edtDataInicial.Top := 65;
    edtDataInicial.Width := 120;
    edtDataInicial.Height := 22;
    edtDataInicial.BorderStyle := bsSingle;
    edtDataInicial.ChildOrder := 109;
    edtDataInicial.Color := clWhite;
    edtDataInicial.Date := 45980.718362395830000000;
    edtDataInicial.Role := '';
    edtDataInicial.Text := '';
    edtClienteNome.SetParentComponent(Self);
    edtClienteNome.Name := 'edtClienteNome';
    edtClienteNome.Left := 486;
    edtClienteNome.Top := 65;
    edtClienteNome.Width := 120;
    edtClienteNome.Height := 22;
    edtClienteNome.ChildOrder := 21;
    edtClienteNome.Enabled := False;
    edtClienteNome.HeightPercent := 100.000000000000000000;
    edtClienteNome.WidthPercent := 100.000000000000000000;
    btnPesquisarCliente.SetParentComponent(Self);
    btnPesquisarCliente.Name := 'btnPesquisarCliente';
    btnPesquisarCliente.Left := 607;
    btnPesquisarCliente.Top := 65;
    btnPesquisarCliente.Width := 30;
    btnPesquisarCliente.Height := 22;
    btnPesquisarCliente.ChildOrder := 22;
    btnPesquisarCliente.HeightPercent := 100.000000000000000000;
    btnPesquisarCliente.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarCliente, Self, 'OnClick', 'btnPesquisarClienteClick');
    cbxVendasExcluidos.SetParentComponent(Self);
    cbxVendasExcluidos.Name := 'cbxVendasExcluidos';
    cbxVendasExcluidos.Left := 486;
    cbxVendasExcluidos.Top := 93;
    cbxVendasExcluidos.Width := 151;
    cbxVendasExcluidos.Height := 22;
    cbxVendasExcluidos.Caption := 'Exibir Exclu'#237'dos?';
    cbxVendasExcluidos.ChildOrder := 9;
    cbxVendasExcluidos.HeightPercent := 100.000000000000000000;
    cbxVendasExcluidos.WidthPercent := 100.000000000000000000;
    frmBanco.SetParentComponent(Self);
    frmBanco.Name := 'frmBanco';
    frmBanco.Left := 352;
    frmBanco.Top := 158;
    frmBanco.Width := 215;
    frmBanco.Height := 61;
    frmBanco.TabOrder := 11;
    frmBanco.Visible := False;
    frmBanco.cbbDataBasePesquisa.Height := 21;
    btnPesquisarVenda.SetParentComponent(Self);
    btnPesquisarVenda.Name := 'btnPesquisarVenda';
    btnPesquisarVenda.Left := 352;
    btnPesquisarVenda.Top := 228;
    btnPesquisarVenda.Width := 96;
    btnPesquisarVenda.Height := 25;
    btnPesquisarVenda.Caption := 'Pesquisar';
    btnPesquisarVenda.ChildOrder := 11;
    btnPesquisarVenda.HeightPercent := 100.000000000000000000;
    btnPesquisarVenda.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarVenda, Self, 'OnClick', 'btnPesquisarVendaClick');
    Vendas_ServicosDataset.SetParentComponent(Self);
    Vendas_ServicosDataset.Name := 'Vendas_ServicosDataset';
    Vendas_ServicosDataset.EntitySetName := 'Vendas_Servicos';
    Vendas_ServicosDataset.Connection := DMConnection.ApiConnection;
    Vendas_ServicosDataset.Left := 72;
    Vendas_ServicosDataset.Top := 144;
    Vendas_ServicosDatasetcodigo_interno.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetcodigo_interno.Name := 'Vendas_ServicosDatasetcodigo_interno';
    Vendas_ServicosDatasetcodigo_interno.FieldName := 'codigo_interno';
    Vendas_ServicosDatasetcodigo_interno.Required := True;
    Vendas_ServicosDatasetnota_numero.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetnota_numero.Name := 'Vendas_ServicosDatasetnota_numero';
    Vendas_ServicosDatasetnota_numero.FieldName := 'nota_numero';
    Vendas_ServicosDatasetnota_numero.Size := 255;
    Vendas_ServicosDatasetclienterazao_social_nome.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetclienterazao_social_nome.Name := 'Vendas_ServicosDatasetclienterazao_social_nome';
    Vendas_ServicosDatasetclienterazao_social_nome.FieldName := 'cliente.razao_social_nome';
    Vendas_ServicosDatasetnota_emissao.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetnota_emissao.Name := 'Vendas_ServicosDatasetnota_emissao';
    Vendas_ServicosDatasetnota_emissao.FieldName := 'nota_emissao';
    Vendas_ServicosDatasetnota_emissao.DisplayFormat := 'dd/mm/yy';
    Vendas_ServicosDatasetnota_entrada_saida.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetnota_entrada_saida.Name := 'Vendas_ServicosDatasetnota_entrada_saida';
    Vendas_ServicosDatasetnota_entrada_saida.FieldName := 'nota_entrada_saida';
    Vendas_ServicosDatasetnota_entrada_saida.DisplayFormat := 'dd/mm/yy';
    Vendas_ServicosDatasetnota_valor_total.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetnota_valor_total.Name := 'Vendas_ServicosDatasetnota_valor_total';
    Vendas_ServicosDatasetnota_valor_total.FieldName := 'nota_valor_total';
    Vendas_ServicosDatasetnota_valor_total.DisplayFormat := '#,##0.00';
    Vendas_ServicosDatasetfuncionarionome.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetfuncionarionome.Name := 'Vendas_ServicosDatasetfuncionarionome';
    Vendas_ServicosDatasetfuncionarionome.FieldName := 'funcionario.nome';
    Vendas_ServicosDatasetexcluido.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetexcluido.Name := 'Vendas_ServicosDatasetexcluido';
    Vendas_ServicosDatasetexcluido.FieldName := 'excluido';
    Vendas_ServicosDatasetinclusao.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetinclusao.Name := 'Vendas_ServicosDatasetinclusao';
    Vendas_ServicosDatasetinclusao.FieldName := 'inclusao';
    Vendas_ServicosDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Vendas_ServicosDatasetalteracao.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetalteracao.Name := 'Vendas_ServicosDatasetalteracao';
    Vendas_ServicosDatasetalteracao.FieldName := 'alteracao';
    Vendas_ServicosDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Vendas_ServicosDatasetexclusao.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetexclusao.Name := 'Vendas_ServicosDatasetexclusao';
    Vendas_ServicosDatasetexclusao.FieldName := 'exclusao';
    Vendas_ServicosDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Vendas_ServicosDatasetid.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetid.Name := 'Vendas_ServicosDatasetid';
    Vendas_ServicosDatasetid.Tag := 1;
    Vendas_ServicosDatasetid.FieldName := 'id';
    Vendas_ServicosDatasetid.Required := True;
    Vendas_ServicosDatasetnfse_id.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetnfse_id.Name := 'Vendas_ServicosDatasetnfse_id';
    Vendas_ServicosDatasetnfse_id.Tag := 1;
    Vendas_ServicosDatasetnfse_id.FieldName := 'nfse_id';
    Vendas_ServicosDatasetnfsenfse_xml_s3.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetnfsenfse_xml_s3.Name := 'Vendas_ServicosDatasetnfsenfse_xml_s3';
    Vendas_ServicosDatasetnfsenfse_xml_s3.Tag := 1;
    Vendas_ServicosDatasetnfsenfse_xml_s3.FieldName := 'nfse.nfse_xml_s3';
    Vendas_ServicosDatasetnfseanexo_sincronizado.SetParentComponent(Vendas_ServicosDataset);
    Vendas_ServicosDatasetnfseanexo_sincronizado.Name := 'Vendas_ServicosDatasetnfseanexo_sincronizado';
    Vendas_ServicosDatasetnfseanexo_sincronizado.FieldName := 'nfse.anexo_sincronizado';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Vendas_ServicosDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 248;
    tmrConsulta.Top := 172;
    XDataWebClient.SetParentComponent(Self);
    XDataWebClient.Name := 'XDataWebClient';
    XDataWebClient.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebClient, Self, 'OnLoad', 'XDataWebClientLoad');
    SetEvent(XDataWebClient, Self, 'OnError', 'XDataWebClientError');
    XDataWebClient.Left := 472;
    XDataWebClient.Top := 256;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    btnExportarExcel.AfterLoadDFMValues;
    cbbVendasNfse.AfterLoadDFMValues;
    edtDataFinal.AfterLoadDFMValues;
    edtDataInicial.AfterLoadDFMValues;
    edtClienteNome.AfterLoadDFMValues;
    btnPesquisarCliente.AfterLoadDFMValues;
    cbxVendasExcluidos.AfterLoadDFMValues;
    frmBanco.AfterLoadDFMValues;
    frmBanco.cbbDataBasePesquisa.AfterLoadDFMValues;
    btnPesquisarVenda.AfterLoadDFMValues;
    Vendas_ServicosDataset.AfterLoadDFMValues;
    Vendas_ServicosDatasetcodigo_interno.AfterLoadDFMValues;
    Vendas_ServicosDatasetnota_numero.AfterLoadDFMValues;
    Vendas_ServicosDatasetclienterazao_social_nome.AfterLoadDFMValues;
    Vendas_ServicosDatasetnota_emissao.AfterLoadDFMValues;
    Vendas_ServicosDatasetnota_entrada_saida.AfterLoadDFMValues;
    Vendas_ServicosDatasetnota_valor_total.AfterLoadDFMValues;
    Vendas_ServicosDatasetfuncionarionome.AfterLoadDFMValues;
    Vendas_ServicosDatasetexcluido.AfterLoadDFMValues;
    Vendas_ServicosDatasetinclusao.AfterLoadDFMValues;
    Vendas_ServicosDatasetalteracao.AfterLoadDFMValues;
    Vendas_ServicosDatasetexclusao.AfterLoadDFMValues;
    Vendas_ServicosDatasetid.AfterLoadDFMValues;
    Vendas_ServicosDatasetnfse_id.AfterLoadDFMValues;
    Vendas_ServicosDatasetnfsenfse_xml_s3.AfterLoadDFMValues;
    Vendas_ServicosDatasetnfseanexo_sincronizado.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
    XDataWebClient.AfterLoadDFMValues;
  end;
end;

end.
